// hooks/useCounterAnimation.js
import { useEffect } from 'react';

export const useCounterAnimation = (configs, duration = 200) => {
  useEffect(() => {
    const formatNumber = (num) => new Intl.NumberFormat('ru-RU').format(num);

    const animateCounter = (selector, delay) => {
      setTimeout(() => {
        document.querySelectorAll(selector).forEach((counter) => {
          const target = Number(counter.dataset.count);

          if (!target || target <= 0) {
            counter.textContent = formatNumber(0);
            return;
          }

          let current = 0;
          const step = target / duration;

          const update = () => {
            current += step;
            const value = Math.ceil(current);

            if (current < target) {
              counter.textContent = formatNumber(value);
              requestAnimationFrame(update);
            } else {
              counter.textContent = formatNumber(target);
            }
          };

          update();
        });
      }, delay);
    };

    configs.forEach(({ selector, delay = 0 }) => {
      animateCounter(selector, delay);
    });
  }, [configs, duration]);
};
